<button
  type="button"
  class="theme-toggle"
  (click)="themeService.toggleTheme()"
  [attr.aria-label]="ariaLabel()"
>
  @if (themeService.isDark()) {
    <svg
      class="theme-icon"
      aria-hidden="true"
      viewBox="0 0 24 24"
      width="20"
      height="20"
      fill="none"
    >
      <circle cx="12" cy="12" r="4" stroke="currentColor" stroke-width="2" />
      <path
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        d="M12 2v2m0 16v2M4.93 4.93l1.41 1.41m11.32 11.32l1.41 1.41M2 12h2m16 0h2M4.93 19.07l1.41-1.41m11.32-11.32l1.41-1.41"
      />
    </svg>
  } @else {
    <svg
      class="theme-icon"
      aria-hidden="true"
      viewBox="0 0 24 24"
      width="20"
      height="20"
      fill="currentColor"
    >
      <path
        d="M21.64 13a9 9 0 1 1-10.73-10.73 1 1 0 0 1 1.3 1.3 6 6 0 0 0 8.14 8.14 1 1 0 0 1 1.29 1.29Z"
      />
    </svg>
  }
</button>
